/* eslint-disable eqeqeq */
import React, { useContext, useState } from "react";
import { Theme } from "@rjsf/bootstrap-4";
import { withTheme, utils } from "@rjsf/core";
import { getCokkie, logout } from "../../../login/Login";
import {
  Badge,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { alertContext } from "../../../../components/modal/ModalComponent";
import useFetch from "../../../../components/useFetch";
import Loader from "../../../../components/Loader";
import Configuration from "../../../../components/modal/NavPanes/Configuration";
import ErrorScreen from "../../../../components/error/ErrorScreen";

import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import { CustomWidget } from "../../../../components/widgets/CustomWidgets";
import VideoRecorder from "./VideoRecorder";
import "./addData.scss";
import { CloseIcon } from "../../../Common/SvgIcons/WorkflowIcons";

var activeStep = 0;
var customUpload = false;
const S3_BUCKET = `${window.ENV.AWS_DATASET_UPLOAD}`;
const REGION = `${window.ENV.AWS_REGION}`;

function AddtoHub({ datasetId, close }) {
  const setAlert = useContext(alertContext);
  const [schema, setSchema] = useState();
  const [uischema, setUischema] = useState();
  const [submited, setSubmited] = useState();
  const [tempCredentials, setTempcredentials] = useState();

  // track unsaved changes + dialog
  const [isDirty, setIsDirty] = useState(false);
  const [showUnsaved, setShowUnsaved] = useState(false);

  // keep original schema (for simple-form detection / required checks)
  const [internalSchema, setInternalSchema] = useState();
  const formRef = React.useRef(null);

  const registry = utils.getDefaultRegistry();
  const defaultFileWidget = registry.widgets["FileWidget"];
  const defaultRangeWidget = registry.widgets["RangeWidget"];
  Theme.widgets["FileWidget"] = defaultFileWidget;
  Theme.widgets["RangeWidget"] = defaultRangeWidget;
  const Form = withTheme(Theme);

  const url = datasetId
    ? `forms/hub/add_dataset?dataset_id=${datasetId}`
    : `forms/model_hub/add_to_model_hub`;

  const { data, loading, error, setLoad, status } = useFetch(url, "get");
  const steps = data?.steppers;

  React.useEffect(() => {
    if (!data) return;
    activeStep = data?.active_step ?? 0;

    // remove form title to avoid duplication with side panel header
    const baseSchema = data?.json_schema;
    const stripped =
      baseSchema && typeof baseSchema === "object"
        ? { ...baseSchema, title: undefined }
        : baseSchema;

    setSchema(stripped);
    setInternalSchema(stripped);
    setUischema(data?.ui_schema || {});
  }, [data]);

  // detect the special small hub form safely
  const isSimpleForm = React.useMemo(() => {
    if (!internalSchema) return false;
    if (!Array.isArray(steps)) return false;
    if (steps.length !== 2 || steps[1] !== "Summary") return false;

    const props = Object.keys(internalSchema.properties || {});

    const hasVersion =
      props.includes("Select Version") || props.includes("Version");

    const hasTags =
      props.includes("Keywords") ||
      props.includes("Tags") ||
      props.includes("Tags (Keywords)");

    const hasAccess =
      props.includes("Access") ||
      props.includes("Access & Visibility");

    return hasVersion && hasTags && hasAccess;
  }, [steps, internalSchema]);


  // UI overrides ONLY for that small hub form
  const hubUiOverrides = React.useMemo(
    () => ({
      // VERSION (already working)
      "Select Version": {
        "ui:title": "Version",
        "ui:widget": "versionSelect",
      },

      // TAGS (already working)
      Keywords: {
        "ui:title": "Tags (Keywords)",
        "ui:widget": "tagsInput",
        "ui:options": {
          placeholder: "Add keyword (e.g., climate, sensor) and press Enter",
          addButtonText: "+ Add Tag",
          wrapperClassName: "hub-tags",
        },
      },

      // ACCESS (already working)
      Access: {
        "ui:title": "Access & Visibility",
        "ui:widget": "accessCard",
        "ui:help": (
          <p className="text-secondary">
            Visibility setting controls who can view and use the dataset on the platform.
          </p>
        ),
        "ui:options": {
          cardClassName: "hub-access-card",
          descriptions: {
            Public:
              "Anyone can view, use, and redistribute this dataset.",
            Private:
              "Only you and explicitly invited collaborators can access it.",
          },
        },
      },

      // 🔹 CITATIONS – NEW
      Citations: {
        "ui:widget": "citationsField",
        "ui:options": {
          placeholder: "https://doi.org/... or other citation",
        },
      },

      // 🔹 LICENSE – NEW
      License: {
        "ui:title": "License",
        "ui:widget": "licenseSelect",
      },
    }),
    []
  );




  // final uiSchema passed to the form
  const enhancedUiSchema = React.useMemo(() => {
    if (!isSimpleForm) {
      return uischema || {};
    }
    return {
      ...(uischema || {}),
      ...hubUiOverrides,
    };
  }, [uischema, hubUiOverrides, isSimpleForm]);

  const onSubmit = ({ formData }, e) => {
    e.preventDefault();
    setLoad(true);

    const payload = { ...submited, ...formData };
    setSubmited(payload);
    let cokkie = getCokkie("jwtToken");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${cokkie}`);

    const requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: JSON.stringify(payload),
    };

    fetch(
      `${window["ENV"].API_URL}/forms/hub/add_dataset?dataset_id=${datasetId}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        setSchema(result?.json_schema ?? result?.summary);
        setUischema(result?.ui_schema);

        if (result.summary) {
          setSubmited(result.summary);
          let temp = {};
          temp.configuration = result?.summary;
          setSchema(temp);
        }
        activeStep = result?.active_step ?? activeStep + 1;

        // after successful step submission we are "clean"
        setIsDirty(false);
      })
      .catch((e) => console.log(e.message + " or Internal Server Error"))
      .finally(() => setLoad(false));
  };

  const back = (e) => {
    e.preventDefault();
    setLoad(true);

    activeStep = activeStep - 2;

    const payload = { ...submited };
    let cokkie = getCokkie("jwtToken");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${cokkie}`);

    const requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: JSON.stringify(payload),
    };

    fetch(
      `${window["ENV"].API_URL}/forms/hub/add_dataset?dataset_id=${datasetId}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        setSchema(result?.json_schema ?? result?.summary);
        setUischema(result?.ui_schema);

        if (result.summary) {
          setSubmited(result.summary);
          let temp = {};
          temp.configuration = result?.summary;
          setSchema(temp);
        }
        activeStep = result?.active_step;
      })
      .catch((e) => console.log(e.message + " or Internal Server Error"))
      .finally(() => setLoad(false));
  };

  const final = (e) => {
    e.preventDefault();
    setLoad(true);

    const payload = { ...schema.configuration };
    let cokkie = getCokkie("jwtToken");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${cokkie}`);

    const requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: JSON.stringify(payload),
    };

    fetch(
      `${window["ENV"].API_URL}/forms/hub/add_dataset?dataset_id=${datasetId}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        setAlert(result.detail);
        setIsDirty(false); // fully saved
        close();
      })
      .catch((e) => console.log(e.message + " or Internal Server Error"))
      .finally(() => setLoad(false));
  };

  // simple one-step submit for small form
  const handleSimpleSubmit = ({ formData }, e) => {
    e.preventDefault();
    setLoad(true);
    setSubmited(formData);

    let cokkie = getCokkie("jwtToken");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${cokkie}`);

    const requestOptions2 = {
      method: "post",
      headers: myHeaders,
      body: JSON.stringify(formData),
    };

    // keep &step for compatibility with existing backend
    fetch(
      `${window["ENV"].API_URL}/forms/hub/add_dataset?dataset_id=${datasetId}&step=${activeStep}`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.detail) {
          setAlert(result.detail);
        }
        setIsDirty(false);
        close();
      })
      .catch((e) => console.log(e.message + " or Internal Server Error"))
      .finally(() => setLoad(false));
  };

  // clicking outside the panel
  const handleBackdropClick = () => {
      setShowUnsaved(true);
  };

  // clicking X / Cancel inside the panel
  const handleCloseClick = () => {
    close();
  };

  const handleDiscardChanges = () => {
    setShowUnsaved(false);
    setIsDirty(false);
    close();
  };

  const handleStayOnPage = () => {
    setShowUnsaved(false);
  };


  const FieldTemplate = (props) => {
    const {
      id,
      classNames,
      label,
      required,
      description,
      errors,
      help,
      children,
    } = props;

    return (
      <div className={classNames}>
        {label && (
          <label htmlFor={id} className="form-label fw-bold mb-1">
            {label}
            {required && <span className="text-danger"> *</span>}
          </label>
        )}

        {description}
        {children}
        {errors}
        {help}
      </div>
    );
  };


  function getFirstMissingRequired(schemaObj, formData) {
    if (!schemaObj || !Array.isArray(schemaObj.required)) return null;

    const data = formData || {};
    for (const key of schemaObj.required) {
      const value = data[key];

      const isEmpty =
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        const fieldSchema =
          schemaObj.properties && schemaObj.properties[key];
        const label = (fieldSchema && fieldSchema.title) || key;
        return `${label} is required`;
      }
    }
    return null;
  }

  const requiredError = getFirstMissingRequired(
    internalSchema || schema,
    submited
  );

  if (loading) {
    return (
      <div className="side-form" onClick={handleBackdropClick}>
        <div
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-5">
            <Loader />
          </div>
        </div>
      </div>
    );
  }

  const isLastStep =
    Array.isArray(steps) && typeof activeStep === "number"
      ? activeStep === steps.length - 1
      : false;

  return (
    <div className="side-form" onClick={handleBackdropClick}>
      {/* panel itself */}
      <div
        onClick={(e) => e.stopPropagation()}
      >
        {/* simple header with close */}
        <div className="side-panel__header">
          <div className="side-panel__title">Export Dataset Version to Platform Hub</div>
          <CloseIcon
            className="wf-icon cursor-pointer text-danger"
            onClick={handleCloseClick}
          />
        </div>

        <div className="p-5 flex-grow-1 overflow-auto">
          {/* stepper */}
          {steps && !isSimpleForm && (
            <ul className="d-flex align-items-center w-100 justify-content-center stepper p-0 mb-4">
              {steps.map((i, index) => {
                const stepLabel = i === "Summary" ? "Review" : i;
                return (
                  <li
                    key={index}
                    className={
                      index <= activeStep
                        ? "active text-center"
                        : "text-center"
                    }
                  >
                    <Badge
                      color={index <= activeStep ? "primary" : "secondary"}
                    >
                      {index + 1}
                    </Badge>
                    <div
                      style={{ display: "unset" }}
                      className="ms-2 active"
                    >
                      {stepLabel}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}

          {schema && isSimpleForm ? (
            <Form
              ref={formRef}
              schema={schema}
              uiSchema={enhancedUiSchema}
              widgets={CustomWidget}
              FieldTemplate={FieldTemplate}
              formData={submited}
              onSubmit={handleSimpleSubmit}
              onChange={({ formData }) => {
                setSubmited(formData);
                setIsDirty(true);
              }}
            >
              <div className="side-panel__footer px-0 mx-0">
                {/* <button className="plain-button2 border rounded w-100" onClick={handleCloseClick}>
                  Cancel
                </button> */}

                <button type="submit" className="btn btn-primary ms-2 mt-0 w-100">
                  Export to Hub
                </button>
              </div>
            </Form>
          ) : (
            <ErrorScreen message={"No form Found"} />
          )}

        </div>
      </div>

      {/* Unsaved changes modal – text based on our form */}
      <Modal
        isOpen={showUnsaved}
        toggle={handleStayOnPage}
        centered
        size="md"
        className="unsaved-modal"
        backdrop="static"
      >
        <div className="unsaved-modal__content">
          <div className="d-a justify-content-between mb-4">
            <h4 className="unsaved-modal__title mb-0">Unsaved Changes</h4>
            <CloseIcon className="wf-icon text-secondary cursor-pointer button" onClick={handleStayOnPage}/>
          </div>


          <p className="text-secondary">
            There are unsaved changes to the{" "}
            {internalSchema?.title ||
              schema?.title ||
              "dataset configuration"}
            . Are you sure you want to discard your changes?
          </p>

          {requiredError && (
            <p className="unsaved-modal__error">
              Cannot save due to error: {requiredError}
            </p>
          )}

          <div className="unsaved-modal__footer">
            <div className="unsaved-modal__left">

            </div>

            <Button
              color="primary"
              onClick={handleDiscardChanges}
            >
              Discard
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}


export default React.memo(AddtoHub);